import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core'
import { Performer } from 'globals/store/performers.data';
import { InformableSection } from 'globals/store/informables.data'
import { publicHelpers } from 'src/app/helpers/public-helpers';
import { OnsiteSingleTimeline } from 'globals/store/onsite.data';
import { LabelMaps, Ranking, Venue } from 'globals/store/events.data';
import { SessionItemInfo, BriefType } from 'globals/store/share.data';
import { Session } from 'globals/store/programs.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { WorkerWithProfile } from 'globals/store/workforce.data';
import { Exhibitor, ExhibitorSummary } from 'globals/store/exhibitors.data';
import { LogisticsInBriefSelection, PublishInBriefSelection } from 'globals/store/publish.data';
import { JoiResource } from 'globals/store/resources.data';
import { MediaTerms } from 'globals/store/events.data';
import { EntityBase } from 'globals/store/entity.shared.data';
import { Dictionary } from '@ngrx/entity';
import { Attendee } from 'globals/store/attendees.data';
import { TipTextComponent } from '../misc/tip-text.component';
import { ExpandingWrapperComponent } from '../wrappers/expanding-wrapper.component';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { GreyWrapperComponent } from '../wrappers/grey-wrapper.component';
import { AttendeeProfileComponent } from 'src/app/modules/attendees/attendee-profile.component';
import { PerformerEditProfileComponent } from 'src/app/modules/share/share.editPerformerForm.component';
import { ExhibitorProfileComponent } from 'src/app/modules/exhibitors/exhibitor-profile.component';
import { ResourceProfileComponent } from 'src/app/modules/resources/resource-profile.component';
import { TextNoTextComponent } from '../misc/text-no-text.component';
import { BriefTimelineComponent } from './briefTimeline.component';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { environment } from '../../../environments/environment';
import { BriefActions } from 'src/app/store/share.brief.functions';
import { WorkforceContactProfileComponent } from '../performers/workforce-contact-profile.component';
import { ActionBarComponent } from './actionBar.component';
import { PerformerProfileComponent } from '../performers/performerProfile.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { InformablePublicComponent } from '../informable/informable.public.component';

@Component({
    selector: 'brief-view',
    templateUrl: 'briefView.html',
    styleUrls: ['./briefView.scss'],
    standalone: true,
    imports: [TipTextComponent, ExpandingWrapperComponent, IconComponent, CommonModule, GreyWrapperComponent, AttendeeProfileComponent, ExhibitorProfileComponent, ResourceProfileComponent, TextNoTextComponent, BriefTimelineComponent, ActionBarComponent, InformablePublicComponent, FindByIdPipe,  PerformerProfileComponent, WorkforceContactProfileComponent]
})
export class BriefViewComponent implements OnInit {

  @Input() publicView: boolean;
  @Input() performer:Performer
  @Input() exhibitor: Exhibitor
  @Input() resource: JoiResource
  @Input() attendee: Attendee
  @Input() entity: EntityBase

  @Input() exhibitorSummaries: ExhibitorSummary[]
  @Input() briefType: BriefType
  @Input() briefActions: BriefActions
  @Input() briefProgramPublishes: PublishInBriefSelection[]
  @Input() briefLogisticsViews: LogisticsInBriefSelection[]
  @Input() briefOnsiteViews: LogisticsInBriefSelection[]
  @Input() performerRoles: Dictionary<Ranking>

  touchedActions: boolean // Don't want actions to reset after starting to open them - should function the same inside or out of the app so no dynamic updating
  actions: BriefActions
  nActionsIncomplete: number = 0
  openedActionUrls: Set<string> = new Set()

  @Input() shareCode: string


  @Input() performers: { [pId: string]: Performer }
  @Input() sponsors: { [key: string]: Sponsor }
  @Input() sponsorTypes: { [tId:string]: Ranking }

  @Input() addAssetForSessionShareIds: { [sessionId:string]: string }
  @Input() showEditProfileButton = false

  @Input() eventTitle: string
  @Input() eventId: string

  @Input() mediaTerms: MediaTerms[]
  @Input() venues: { [vId:string]: Venue }

  @Input() unavailable = false
  @Input() timeline: OnsiteSingleTimeline[]
  @Input() labelMaps: LabelMaps
  @Input() showActivityStatus = true
  @Input() assetInfos: { [sesAndPerfId:string]: SessionItemInfo } = {}
  @Input() sessionMap: { [sId: string]: Session }
  @Input() singleEntityInformable:InformableSection[]
  @Input() allEntityInformable:InformableSection[]
  @Input() timelineNeedsAction = true
  @Input() receiveAssetsTemplate: TemplateRef<any>;
  @Input() workforceContactProfile: WorkerWithProfile
  @Input() workforceContactInactive = true

  @Input() lowerEntity = ''
  @Input() capitalEntity = ''

  @Output() acceptMediaTerms: EventEmitter<string> = new EventEmitter() // should probably only listen in for the public component
  @Output() editProfileUrl: EventEmitter<null> = new EventEmitter()

  publicHelpers = publicHelpers
  shareBaseUrl = environment.joi.shareBase


  constructor(){}
  ngOnInit(){
    // setTimeout(() => console.log({ assetInfos: this.assetInfos }), 2000)
    // console.log({ performerBriefs:this.performerBriefs});
  }

  openActionUrl(url: string) {
    console.log({ url })
    if (this.openedActionUrls.has(url)) return
    this.actions.submitted += 1
    this.touchedActions = true
    this.openedActionUrls.add(url)
    publicHelpers.openInNewTab(`${this.shareBaseUrl}${url}`)
  }

  openShare(url: string) {
    publicHelpers.openInNewTab(`${this.shareBaseUrl}${url}`)
  }

  acceptTerms(termsId: string) {
    this.touchedActions = true
    this.nActionsIncomplete -= 1
    this.actions.submitted += 1
    
    this.actions.terms.find(t => t.id === termsId).submitted = true
    this.acceptMediaTerms.emit(termsId)
  }

  ngOnChanges(changes) {
    /* if (changes.allPerformersInformables && changes.allPerformersInformables.currentValue) {
      this.allEntityInformable = changes.allEntityInformable.currentValue.filter((info: InformableSection) => info.items.filter(item => item.description || (item.files && item.files.length)).length)
    } */
    if (!this.touchedActions && changes.briefActions && changes.briefActions.currentValue) {
      this.actions = jsonCopyObject(changes.briefActions.currentValue)
      this.nActionsIncomplete = this.actions.total - this.actions.submitted
    }
  }

  trackByDate(index, item: OnsiteSingleTimeline) {
    return item.date.toString()
  }
}